import { memo } from 'react';

import { Tooltip, Typography } from '@mui/material';

import { ReactComponent as InfoIcon } from '@/assets/icons/form-info-icon.svg';

export interface MultiValueCellProps {
  values: string[];
  /** Already-translated plural summary, e.g. t('multiple_locations', { count }). */
  summary: string;
}

export const MultiValueCell = memo(({ values, summary }: MultiValueCellProps) => (
  <Typography>
    <Tooltip
      title={
        values.length > 1 ? (
          <ul style={{ margin: 0, paddingLeft: '10px' }}>
            {values.map((value, key) => (
              <li key={key}>{value}</li>
            ))}
          </ul>
        ) : undefined
      }
    >
      <span>
        {values.length === 0 ? '' : values.length === 1 ? values[0] : summary}
        {values.length > 1 && (
          <InfoIcon style={{ marginLeft: '0.5rem', marginBottom: '-0.125rem' }} />
        )}
      </span>
    </Tooltip>
  </Typography>
));
MultiValueCell.displayName = 'MultiValueCell';
